import React from 'react'
import classnames from 'classnames'
import {
  ButtonVariant,
  ModalCloseButton,
  ModalWrapper,
  OvalButton,
  Spacer,
} from '@revelrygroup/components'

import CartProducts from '../CartProducts'
import styles from './styles.module.scss'
import useCartContext from '../../hooks/useCartContext'
import useFlowerProductsContext from '../../hooks/useFlowerProductsContext'

interface Props {
  onCheckout: () => void
  onClose: () => void
}

const Basket: React.FC<Props> = (props) => {
  const [visible, setVisible] = React.useState(false)
  const cartCtx = useCartContext()
  const flowerProductsCtx = useFlowerProductsContext()
  const wrapperClassName = classnames(styles.wrapper, 'Modal-outer', {
    [styles.wrapperVisible]: visible,
  })
  const modalWrapperClassName = classnames(styles.modalWrapper, {
    [styles.modalWrapperVisible]: visible,
  })

  React.useEffect(() => {
    setTimeout(() => {
      setVisible(true)
    }, 100)
  }, [])

  return (
    <ModalWrapper className={modalWrapperClassName} onClose={props.onClose}>
      <div
        className={wrapperClassName}
        id="modal"
        style={{ top: `${Math.round(window.scrollY)}px` }}
      >
        <div>
          <ModalCloseButton onClick={() => props.onClose()} />

          <h2 className="h2">Basket</h2>

          <p className="small">Your Order</p>

          <CartProducts
            productCodeProductMap={flowerProductsCtx.productCodeProductMap}
            includeEstimatedTotal
            loading={cartCtx.loading}
            onRemoveProduct={cartCtx.removeProductFromCart}
            onRemoveTreeProduct={cartCtx.removeTreeProductFromCart}
            shoppingCart={cartCtx.cart}
          />

          <Spacer verticalTop="md">
            <OvalButton
              as={undefined}
              className="bold full-width"
              onClick={() => props.onCheckout()}
              variant={ButtonVariant.DEFAULT_DARK}
            >
              Checkout Now
            </OvalButton>
          </Spacer>

          <Spacer verticalTop="sm">
            <button
              className="link-button full-width centered-text"
              onClick={() => props.onClose()}
              type="button"
            >
              Or Continue Shopping
            </button>
          </Spacer>
        </div>
      </div>
    </ModalWrapper>
  )
}

export default Basket
